import { Button, Modal } from '@morressier/alembic';
import { FormProvider, useForm } from 'react-hook-form';
import { Box, Flex, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdd } from '@fortawesome/pro-regular-svg-icons';
import { useEffect } from 'react';
import {
  IOrganizationForm,
  useUserDetailsData
} from 'src/components/UserRegistrationSteps/StepThree/signupHook';
import OrganizationDetailsForm from 'src/components/UserRegistrationSteps/StepTwo/OrgonizationDetailsForm';

const UpdateAffiliationDetailsModal = ({
  isOpen,
  onClose,
  onAdd,
  organizationId,
  affiliationDetails,
  handleAffiliationDuplicateCheck,
  additionalAffiliations
}: {
  isOpen: boolean;
  onClose: () => void;
  onAdd: (affiliation: IOrganizationForm) => void;
  organizationId: string;
  affiliationDetails: IOrganizationForm;
  additionalAffiliations: IOrganizationForm[];
  handleAffiliationDuplicateCheck: (
    additionalAffiliations: IOrganizationForm[],
    affiliationDetails: IOrganizationForm
  ) => boolean;
}) => {
  const { configs } = useUserDetailsData(organizationId || '');

  const newConfig = {
    streetAddress: configs.StreetAddress,
    city: configs.City,
    stateOrRegion: configs.StateOrRegion,
    postalCode: configs.PostalCode,
    department: configs.Department,
    country: configs.Country,
    url: configs.Url,
    organizationName: configs.OrganizationName
  };

  const methods = useForm<{
    affiliationDetails: IOrganizationForm;
  }>({
    mode: 'onChange',
    defaultValues: {
      affiliationDetails: affiliationDetails || {}
    }
  });
  const { reset, handleSubmit } = methods;

  useEffect(() => {
    if (isOpen) {
      reset({
        affiliationDetails: affiliationDetails || {}
      });
    }
  }, [isOpen, affiliationDetails, reset]);

  return (
    <Modal
      isOpen={isOpen}
      width="700px"
      onClose={onClose}
      closeButtonProps={{
        visibility: 'hidden'
      }}
    >
      <Box>
        <FormProvider {...methods}>
          <form>
            <Flex direction="column" px={8} pt={8} gap={3}>
              <Box>
                <FontAwesomeIcon icon={faAdd} size="2xl" />
              </Box>
              <Text textStyle="headingGroup">Add Primary Affiliation</Text>
              <OrganizationDetailsForm
                formConfig={newConfig}
                fieldPrefix="affiliationDetails"
                affiliationDetails={affiliationDetails}
              />
              <Flex justify="flex-end" gap={3} my={5}>
                <Button variant="secondary" onClick={onClose}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  onClick={handleSubmit(data => {
                    const isDuplicateFound = handleAffiliationDuplicateCheck(
                      additionalAffiliations,
                      data.affiliationDetails
                    );
                    if (isDuplicateFound) {
                      return;
                    }
                    onAdd(data.affiliationDetails);
                  })}
                >
                  Add Primary Affiliation
                </Button>
              </Flex>
            </Flex>
          </form>
        </FormProvider>
      </Box>
    </Modal>
  );
};

export default UpdateAffiliationDetailsModal;
